import { useFeatureFlag as useFeatureFlagPrimitive, User, } from 'configcat-react';
const useFeatureFlag = (key, defaultValue) => {
    const savedEmail = localStorage.getItem('AptiveQA') || '';
    const userObject = new User(savedEmail);
    return useFeatureFlagPrimitive(key, defaultValue, userObject);
};
export { useFeatureFlag };
